// API records may contain booleans, SQL bit numbers, or legacy string values.
// Never use truthiness: both "false" and "0" are non-empty strings.
export const normalizeToggleValue = value => value === true || value === 1
  || (typeof value === 'string' && ['true', '1', 'on', 'yes'].includes(value.trim().toLowerCase()));
